import React from 'react'
import Container from 'react-bootstrap/Container'
import NavigationBar from './NavigationBar'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Table from 'react-bootstrap/Table'

function Pricing() {

    return (
        <React.Fragment>

            
        <style type="text/css">
            {`

                h1{
                    font-size: 3.5rem;
                }
                p{
                    display: flex;
                    justify-content: center;
                    font-size: 2rem;
                }
                services{
                    display: flex;
                    justify-content: center;
                }
                li{
                    list-style-type: none;
                    position: relative;
                    left: 100px;
                    font-size: 2rem;

                }
                td{
                    padding: 1.2rem;
                }
            `}
            </style>

            <NavigationBar />
            <Container>
            <Jumbotron fluid>
                <Container>
                    <h1>Pricing</h1>
                    <p>
                    Just tell us what you need and we will do the rest for you . It's as simple as that.
                    </p>
                </Container>
            </Jumbotron>

            <services>
                <ul>
                    <li>Web Development</li>
                    <Table striped bordered hover variant="dark">
                        <thead>
                            <tr>
                            <th>#</th>
                            <th>Basic</th>
                            <th>Standard</th>
                            <th>Gold</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>1</td>
                            <td>25$</td>
                            <td>100$</td>
                            <td>400$</td>
                            </tr>
                            <tr>
                            <td>2</td>
                            <td>
                                -10 days delivery<br />
                                -3 page website<br />
                                -Source code<br />
                                -Responsive design

                            </td>
                            <td>
                                -20 days delivery<br />
                                -3+ page website<br />
                                -Source code<br />
                                -Responsive design
                            </td>
                            <td>
                                -30 days delivery<br />
                                -10/10+ page website<br />
                                -Source code<br />
                                -Responsive design
                            </td>
                            </tr>
                            
                        </tbody>
                    </Table>
                    <li>Mobile Development</li>
                    <Table striped bordered hover variant="dark">
                        <thead>
                            <tr>
                            <th>#</th>
                            <th>Basic</th>
                            <th>Standard</th>
                            <th>Gold</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>1</td>
                            <td>25$</td>
                            <td>100$</td>
                            <td>400$</td>
                            </tr>
                            <tr>
                            <td>2</td>
                            <td>
                                -10 days delivery<br />
                                -3 page website<br />
                                -Source code<br />
                                -Responsive design

                            </td>
                            <td>
                                -20 days delivery<br />
                                -3+ page website<br />
                                -Source code<br />
                                -Responsive design
                            </td>
                            <td>
                                -30 days delivery<br />
                                -10/10+ page website<br />
                                -Source code<br />
                                -Responsive design
                            </td>
                            </tr>
                            
                        </tbody>
                    </Table>
                    <li>Desktop App Development</li>
                    <Table striped bordered hover variant="dark">
                        <thead>
                            <tr>
                            <th>#</th>
                            <th>Basic</th>
                            <th>Standard</th>
                            <th>Gold</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>1</td>
                            <td>25$</td>
                            <td>100$</td>
                            <td>400$</td>
                            </tr>
                            <tr>
                            <td>2</td>
                            <td>
                                -10 days delivery<br />
                                -3 page website<br />
                                -Source code<br />
                                -Responsive design

                            </td>
                            <td>
                                -20 days delivery<br />
                                -3+ page website<br />
                                -Source code<br />
                                -Responsive design
                            </td>
                            <td>
                                -30 days delivery<br />
                                -10/10+ page website<br />
                                -Source code<br />
                                -Responsive design
                            </td>
                            </tr>
                            
                        </tbody>
                    </Table>
                    <li>Game Development</li>
                    <Table striped bordered hover variant="dark">
                        <thead>
                            <tr>
                            <th>#</th>
                            <th>Basic</th>
                            <th>Standard</th>
                            <th>Gold</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>1</td>
                            <td>25$</td>
                            <td>100$</td>
                            <td>400$</td>
                            </tr>
                            <tr>
                            <td>2</td>
                            <td>
                                -10 days delivery<br />
                                -3 page website<br />
                                -Source code<br />
                                -Responsive design

                            </td>
                            <td>
                                -20 days delivery<br />
                                -3+ page website<br />
                                -Source code<br />
                                -Responsive design
                            </td>
                            <td>
                                -30 days delivery<br />
                                -10/10+ page website<br />
                                -Source code<br />
                                -Responsive design
                            </td>
                            </tr>
                            
                        </tbody>
                    </Table>
                </ul>
            </services>
            </Container>

            
        </React.Fragment>

        
    )
}

export default Pricing
